import { render, staticRenderFns } from "./edit-popover.vue?vue&type=template&id=df950d3e&scoped=true"
import script from "./edit-popover.vue?vue&type=script&lang=js"
export * from "./edit-popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df950d3e",
  null
  
)

export default component.exports